import { graphql } from "~/gql";
import { useQuery, QueryHookOptions } from "@apollo/client";
import { RoiQueryInput, RoiQueryQuery, RoiQueryQueryVariables } from "~/gql/graphql";

export const ROI_QUERY = graphql(/* GraphQL */ `
  query roiQuery($input: RoiQueryInput!) {
    roiQuery(input: $input) {
      roiTimeSeriesDataJSON
      timeIntervalsJSON
    }
  }
`);

export function useRoiQuery(
  input: RoiQueryInput,
  options?: Omit<QueryHookOptions<RoiQueryQuery, RoiQueryQueryVariables>, "variables">
) {
  return useQuery(ROI_QUERY, {
    variables: { input },
    ...options,
  });
}
